import { IPremadeQuiz } from '@quizzach/interfaces';
import type { AuthorSalesData } from './useAuthorAnalytics';

// Dev-only sales for the author analytics tab; toggled centrally via
// MOCK_AUTHOR_ANALYTICS in mocks.config.ts.

// Seeded PRNG (mulberry32) so the numbers survive a reload
const seededRandom = (seed: number) => {
	return () => {
		seed |= 0;
		seed = (seed + 0x6d2b79f5) | 0;
		let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
		t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
	};
};

export const generateMockAuthorSales = (
	quizzes: IPremadeQuiz[]
): AuthorSalesData[] => {
	const rand = seededRandom(42);
	const now = Math.floor(Date.now() / 1000);
	const halfYear = 182 * 24 * 60 * 60;
	const sales: AuthorSalesData[] = [];

	for (const quiz of quizzes) {
		// Skew per-quiz counts so the list has bestsellers, mid performers and duds
		const tier = rand();
		const copies =
			tier > 0.8
				? 18 + Math.floor(rand() * 22)
				: tier > 0.35
					? 3 + Math.floor(rand() * 9)
					: Math.floor(rand() * 3);

		for (let i = 0; i < copies; i++) {
			sales.push({
				created_at: String(now - Math.floor(rand() * halfYear)),
				price: quiz.price || '4.99',
				premade_quiz: {
					uuid: quiz.uuid,
					title: quiz.title,
					cover_photo: quiz.cover_photo,
					cover_photo_small: quiz.cover_photo_small,
					author: {
						display_name: quiz.author.display_name,
						display_name_slug: quiz.author.display_name_slug || '',
					},
				},
				quiz_type: 'premade',
			});
		}
	}

	return sales;
};
